import { Grid } from '@material-ui/core';
import { CurrencyField, DateField, TextField } from '@roc/ui';
import { fromApiDate, toApiDate } from '../../utils/debtTrackingUtils';

export interface DebtEntryFormValues {
  amount: number | string;
  effectiveDate: string;
  comment: string;
}

interface DebtEntryFieldsProps {
  values: DebtEntryFormValues;
  onChange: (field: keyof DebtEntryFormValues, value: DebtEntryFormValues[keyof DebtEntryFormValues]) => void;
  recordedByName: string;
}

// Financing amount / effective date / recorded by / comment inputs shared by the "Add Entry" and loan detail dialogs.
// The amount entered replaces the loan's current financing amount.
export const DebtEntryFields = ({ values, onChange, recordedByName }: DebtEntryFieldsProps) => (
  <Grid container spacing={2}>
    <Grid item xs={12} md={6}>
      <CurrencyField
        testId="debtEntryAmount"
        label="Financing Amount"
        required
        fullWidth
        variant="outlined"
        value={values.amount}
        onChange={(_, value) => onChange('amount', value)}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <DateField
        testId="debtEntryEffectiveDate"
        label="Effective Date"
        required
        fullWidth
        format="MM/dd/yyyy"
        inputVariant="outlined"
        value={fromApiDate(values.effectiveDate)}
        onChange={date => onChange('effectiveDate', toApiDate(date))}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <TextField
        testId="debtEntryRecordedBy"
        label="Recorded By"
        variant="outlined"
        fullWidth
        value={recordedByName}
        disabled
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        testId="debtEntryComment"
        label="Comments"
        variant="outlined"
        fullWidth
        multiline
        minRows={3}
        placeholder="Reason for the new amount (draw, paydown, correction...) to keep in the history"
        value={values.comment}
        onChange={e => onChange('comment', e.target.value)}
      />
    </Grid>
  </Grid>
);
